export function important<T>(value: T) {
  return (value + " !important") as T;
}
